var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5161 1.48279C13.8836 0.850286 13.0419 0.501953 12.1453 0.501953C11.2504 0.501953 10.4069 0.850286 9.77361 1.48445L1.09949 10.1586C0.992783 10.2653 0.916997 10.3986 0.880274 10.5453L0.462692 15.0843C0.460353 15.1097 0.460353 15.1352 0.462692 15.1606C0.483749 15.3897 0.68659 15.5584 0.915777 15.5374L5.45618 15.1203C5.60195 15.0845 5.73613 15.0078 5.84284 14.9011L14.517 6.22695C15.1503 5.59362 15.4986 4.75029 15.4986 3.85529C15.4986 2.95945 15.1503 2.11612 14.5161 1.48279ZM12.6995 5.68739L13.3385 5.04844C13.6586 4.72832 13.832 4.30918 13.832 3.85529C13.832 3.40066 13.6587 2.98194 13.3377 2.6613C13.0178 2.34145 12.6001 2.16862 12.1453 2.16862C11.6915 2.16862 11.2728 2.34194 10.9522 2.66296L10.3137 3.3015L12.6995 5.68739ZM2.3969 11.2182L2.16679 13.8332L4.78286 13.6041L11.5209 6.86591L9.13508 4.48001L2.3969 11.2182Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSingle);
export default __webpack_public_path__ + "static/media/editSingle.e804e8d6.svg";
export { ForwardRef as ReactComponent };